import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { User } from '../models/user';
import { Http } from '@angular/http';
import { SideNavComponent } from '../modules/layout/side-nav/side-nav.component';
import util from '../util';


@Injectable({
  providedIn: 'root'
})
export class UserService {
  urlAPI = util.api; // api rest fake
  private usersCache: any = null;
  private usersPromise: Promise<any> = null;

  constructor(
    private httpClient: HttpClient,
  ) { }
  @Output()

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  }
  salvarusuario(form) {
    let res = this.httpClient.post<User>(this.urlAPI + 'register', form)
      .toPromise().then((res) => {

        return res
      }).catch((err) => {
        return err
      })
    return res
  }
  salvarusuarioBypass(form) {
    let res = this.httpClient.post<User>(this.urlAPI + 'register/bypass', form)
      .toPromise().then((res) => {

        return res
      }).catch((err) => {
        return err
      })
    return res
  }
  getusuarios() {
    // Retorna cache se disponível
    if (this.usersCache) {
      return Promise.resolve(this.usersCache);
    }

    // Se já existe uma requisição em progresso, retorna a mesma promise
    if (this.usersPromise) {
      return this.usersPromise;
    }

    this.usersPromise = this.httpClient.get<User>(this.urlAPI + 'usuarioAdm', { observe: 'response' })
      .toPromise().then((res) => {
        this.usersCache = res;
        this.usersPromise = null;
        return res;
      }).catch((err) => {
        this.usersPromise = null;
        return err;
      });

    return this.usersPromise;
  }

  // Força a invalidação do cache (use quando houver alteração que exija recarga)
  invalidateUsersCache() {
    this.usersCache = null;
  }
  getusuariosunico(id) {
    let res = this.httpClient.get<User>(this.urlAPI + 'usuario/grupo/' + id, { observe: 'response' })
      .toPromise().then((res) => {
        return res
      }).catch((err) => {
        return err
      })
    return res
  }
  gerarRecibo(item) {
    let res = this.httpClient.post<User>(this.urlAPI + 'Recibo/gerar', item)
      .toPromise().then((res) => {

        return res
      }).catch((err) => {
        return err
      })
    return res
  }
  alterarusuario(id, form) {
    form.userAdmin = sessionStorage.getItem("usuario");
    let res = this.httpClient.post<User>(this.urlAPI + 'usuario/alterar/' + id, form)
      .toPromise().then((res) => {

        return res
      }).catch((err) => {
        return err
      })
    return res

  }
  alterardadoscomplementares(id, form) {
    form.userAdmin = sessionStorage.getItem("usuario");
    let res = this.httpClient.post<User>(this.urlAPI + 'dadoscomplementares/alterar/' + id, form)
      .toPromise().then((res) => {

        return res
      }).catch((err) => {
        return err
      })
    return res

  }
  getAuditoria(data) {
    let res = this.httpClient.post<User>(this.urlAPI + 'auditoria/listarmes', data)
      .toPromise().then((res) => {

        return res
      }).catch((err) => {
        return err
      })
    return res
  }
  subirDocument(id, fd) {
    let res = this.httpClient.post<User>(this.urlAPI + 'usuario/comprovante/' + id, fd)
      .toPromise().then((res) => {
        return res
      }).catch((err) => {
        return err
      })
    return res
  }
  subirfotoPerfil(id, fd) {
    let res = this.httpClient.post<User>(this.urlAPI + 'usuario/foto/' + id, fd)
      .toPromise().then((res) => {
        return res
      }).catch((err) => {
        return err
      })
    return res
  }
  RecusarDocumento(id, env) {
    let res = this.httpClient.post<User>(this.urlAPI + 'usuario/docrecusado/' + id, env)
      .toPromise().then((res) => {
        return res
      }).catch((err) => {
        return err
      })
    return res
  }
  AprovarDocumento(id, env) {
    let res = this.httpClient.post<User>(this.urlAPI + 'usuario/docaprovada/' + id, env)
      .toPromise().then((res) => {
        return res
      }).catch((err) => {
        return err
      })
    return res
  }
  getCertificados(id) {
    let res = this.httpClient.get(this.urlAPI + 'usuario/certificados/' + id)
      .toPromise().then((res) => {
        return res
      }).catch((err) => {
        return err
      })
    return res
  }
  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}
